<template>
  <v-dialog v-model="display" width="340" persistent>
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="props_date_time"
        v-on="on"
        readonly
        :disabled="disabled_input"
        :dense="dense"
        :rules="rules_apply">
        <template v-slot:progress>
          <slot name="progress">
            <v-progress-linear color="primary" indeterminate absolute height="2"></v-progress-linear>
          </slot>
        </template>
      </v-text-field>
    </template>

    <v-card>
      <v-card-text class="px-0 py-0">
        <v-tabs fixed-tabs v-model="activeTab">
          <v-tab href="#calendar"><v-icon>mdi-calendar</v-icon></v-tab>
          <v-tab href="#timeIcon" :disabled="is_dateSelected"><v-icon>mdi-clock</v-icon></v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item disabled value="calendar">
            <v-date-picker 
              v-model="date"
              @input="showTimePicker"
              full-width
              :max="max_date"
              :min="min_date"
            >
            </v-date-picker>
          </v-tab-item>
          <v-tab-item disabled value="timeIcon">
             <v-time-picker
              ref="timer"
              class="v-time-picker-custom"
              v-model="time"
              full-width
              format="24hr"
              :use-seconds="use_seconds"
              :max="max_time"
              :min="min_time"
            ></v-time-picker>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions" :parent="this">
          <!-- <v-btn color="error lighten-1" text @click.native="clearHandler"> Clear</v-btn> -->
          <v-btn color="error lighten-1" text @click.native="closeHandler"> Close</v-btn>
          <v-btn color="green darken-1" text @click="okHandler" :disabled="date && time ? false : true" >Save</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
export default {
  name: 'CustomDateTimePicker',
  model: {
    prop: 'datetime',
    event: 'input'
  },
  props: {
    datetime: {
      type: [Date, String],
      default: null
    },
    label: {
      type: String,
      default: 'Date & Time'
    },
    max_date: {
      type: [Date, String],
      default: null
    },
    min_date: {
      type: [Date, String],
      default: null
    },

    max_date_time: {
      type: [String],
      default: null
    },
    min_date_time: {
      type: [String],
      default: null
    },
    rules_apply: {
      type: Array,
      default: []
    },
    dense: {
      type: Boolean,
      default: false
    },
    disabled_input: {
      type: Boolean,
      default: false
    },
    use_seconds: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      display: false,
      activeTab: 'calendar',
      date: null,
      time: null,
      props_date_time: null,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    
    min_time(){
      let selected_date = this.dateIFValid(this.date, 'YYYY-MM-DD');
      let temP_date = this.dateIFValid(this.min_date_time, 'YYYY-MM-DD');
      let temP_time = this.dateIFValid(this.min_date_time, 'YYYY-MM-DD HH:mm:ss') ? moment(this.min_date_time).format("HH:mm:ss") : null;
      if (temP_date && selected_date){
        if (new Date(temP_date).getTime() === new Date(selected_date).getTime()) {
          return temP_time
        }else{
          return null;
        }
      }else{
        return null;
      }
    },
    max_time(){
      let selected_date = this.dateIFValid(this.date, 'YYYY-MM-DD');
      let temP_date = this.dateIFValid(this.max_date_time, 'YYYY-MM-DD');
      let temP_time = this.dateIFValid(this.max_date_time, 'YYYY-MM-DD HH:mm:ss') ? moment(this.max_date_time).format("HH:mm:ss") : null;
      if (temP_date && selected_date){
        if (new Date(temP_date).getTime() === new Date(selected_date).getTime()) {
          return temP_time
        }else{
          return null;
        }
      }else{
        return null;
      }
    },

    defaultDateTimeFormat() {
      return 'YYYY-MM-DD' + ' ' + 'HH:mm:ss'
    },
    formattedDatetime() {
      return this.selectedDatetime ? moment(this.selectedDatetime).format(this.defaultDateTimeFormat) : null;
    },
    selectedDatetime() {
      if (this.date && this.time) {
        let datetimeString = this.date + ' ' + this.time
        
        if (this.time.length === 5) {
          datetimeString += ':00'
        }
        return moment(datetimeString).format(this.defaultDateTimeFormat);
      } else {
        return null
      }
    },
    is_dateSelected() {
      return !this.date
    },
  },
  methods: {
    moment,
    init() {
      if (!this.datetime) {
        return
      }
      let initDateTime
      if (this.datetime instanceof Date) {
        initDateTime = this.datetime
      } else if (typeof this.datetime === 'string' || this.datetime instanceof String) {
        // see https://stackoverflow.com/a/9436948
        initDateTime = moment(this.datetime).format(this.defaultDateTimeFormat)
      }

      this.props_date_time = initDateTime;
      this.date = moment(initDateTime).format('YYYY-MM-DD');
      this.$nextTick(() => {
        this.time = moment(initDateTime).format('HH:mm:ss');
      })
    },
    okHandler() {
      this.resetPicker()
      this.$emit('input', this.selectedDatetime)
      this.$emit('save_cancel', 'saved');
    },
    clearHandler() {
      this.resetPicker()
      this.date = ''
      this.time = '00:00:00'

      this.$emit('input', null)
      this.$emit('save_cancel', 'cleared');
    },
    closeHandler() {
      this.resetPicker()
      this.$emit('save_cancel', 'closed');
    },
    resetPicker() {
      this.display = false
      this.activeTab = 'calendar'
      if (this.$refs.timer) {
        this.$refs.timer.selectingHour = true
      }
    },
    showTimePicker() {
      this.activeTab = 'timeIcon'
    }
  },
  watch: {
    date: function() {
      this.time = null;
    },
    datetime: function() {
      this.init()
    }
  }
}
</script>
